import React from "react";
import Noresult from "../assets/images/resultFound.png";

const NoResults = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full text-center p-6">
      {/* Illustration */}
      <div className="relative flex items-center justify-center mb-4">
        <div className="w-28 h-36 bg-gray-100 rounded-xl flex items-center justify-center">
           <div><img src={Noresult} style={{height: "8rem"}}/></div>
        </div>
      </div>

      {/* Heading */}
      <div style={{color: "#333843",
      fontFamily: "Inter",
      fontWeight: "600",
      fontSize: "20px"

      }}>No Results Found</div>

      {/* Description */}
      <p style={{
        color: "#667085",
        fontFamily: "Inter",
        fontWeight: "500",
        fontSize: "14px"
      }}>
        We couldn't find what you search for. Try searching again
      </p>
    </div>
  );
};

export default NoResults;
